import React from "react";
import ReactDOM from "react-dom/client";
// Self-hosted fonts (GDPR: no requests to Google servers)
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/600.css";
import "@/index.css";
import App from "@/App";

// Prerendered pages (scripts/prerender.js) ship static HTML inside #root for
// crawlers. Async content (fetched markdown) makes real hydration mismatch, so
// ponytail: clear and client-render instead of hydrateRoot — same markup+CSS
// repaints immediately, no duplicate-tree fallout.
const container = document.getElementById("root");
container.innerHTML = "";
ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
